<template>
  <div class="mx-auto !max-w-[1292px]">
    <h4
      v-if="adjustedList.length > 0"
      :class="[
        'mb-5 px-5 pt-10 pt-20 font-serif text-xl lg:mb-10 lg:text-2xl',
        useDarkMode ? 'text-white' : 'text-black',
      ]"
    >
      {{ isProtest ? $t('petitionForm.theLastProtests') : $t('petitionForm.theLastPetitions') }}
    </h4>
    <div
      v-if="adjustedList.length > 0"
      class="grid grid-flow-row-dense grid-rows-3 gap-4 lg:grid-cols-3"
    >
      <template v-for="comment in adjustedList" :key="comment.id">
        <div
          v-if="comment.message"
          :class="[
            'max-w-xl rounded-2xl px-10 py-4 shadow-[0_5px_15px_0px_rgba(0,155,181,0.22)] transition duration-500 hover:shadow-[0_5px_15px_0px_rgba(0,155,181,0.32)]',
            useDarkMode ? 'bg-blue-darkest' : 'bg-white',
          ]"
        >
          <div class="mt-4">
            <p
              :class="['text-md mt-4 font-bold', useDarkMode ? 'text-grey-light' : 'text-gray-600']"
            >
              {{ comment.message }}
            </p>
            <div :class="['mt-2 py-6 text-sm font-normal', useDarkMode ? 'text-grey-light' : '']">
              - {{ comment.firstname }}
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref as dbRef, query, limitToLast } from 'firebase/database'
import { useDatabaseList } from 'vuefire'

interface Comment {
  date: string
  firstname: string
  lastname: string
  message: string
  name: string
}

const props = defineProps({
  isProtest: { type: Boolean, required: false, default: false },
  formId: {
    type: String,
    required: true,
  },
  useDarkMode: { type: Boolean, required: false, default: false },
})

const length = 9

const adjustedList = computed(() => {
  const withMessage = comments.value.filter(comment => comment.message)
  const limitedList = withMessage.slice(0, length)
  return limitedList
})

const db = useDatabase()
const cRef = dbRef(db, 'comments/' + props.formId)
const comments = useDatabaseList<Comment>(query(cRef, limitToLast(150)))
</script>
